import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  sepPlanCount: 0,
  isSepPlanError: false,
  isSepPlanLoading: false
};

const sepPlansSlice = createSlice({
  name: 'sepPlansSlice',
  initialState,
  reducers: {
    setSepPlanCount: (state, action) => {
      state.sepPlanCount = action.payload;
    },
    setSepPlanError: (state, action) => {
      state.isSepPlanError = action.payload;
    },
    setSepPlanLoading: (state, action) => {
      state.isSepPlanLoading = action.payload;
    }
  }
});

export const { setSepPlanCount, setSepPlanError, setSepPlanLoading } =
  sepPlansSlice.actions;

export const sepPlansReducer = sepPlansSlice.reducer;
